export const NOT_DELETED = 'NOT_DELETED';
export const SOFT_DELETED = 'SOFT_DELETED';
export const HARD_DELETED = 'HARD_DELETED';